import type { FunctionComponent } from 'react';

import { useModifiers } from '../../../styles/hooks/useModifiers';

import styles from './card.module.css';

export type CardValue = '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | 'J' | 'Q' | 'K' | 'A';

export enum CardSuite {
  Hearts = 'Hearts',
  Clubs = 'Clubs',
  Spades = 'Spades',
  Diamonds = 'Diamonds',
}

export interface CardProps {
  value: CardValue;
  suite: CardSuite;
  mini?: boolean;
  className?: string;
}

export interface CardItem {
  value: CardValue;
  suite: CardSuite;
}

export const cards = {
  suite: [
    CardSuite.Clubs,
    CardSuite.Diamonds,
    CardSuite.Hearts,
    CardSuite.Spades,
  ] /*Do not change order due to History*/,
  value: ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'],
};

export const getCardInfo = (cardNumber: number): CardItem => {
  const valueIndex = cardNumber % 13;
  const suiteIndex = Math.floor(cardNumber / 13);

  const value = cards.value[valueIndex] as CardValue;
  const suite = cards.suite[suiteIndex];

  return { value, suite };
};

export const Card: FunctionComponent<CardProps> = ({ value = 2, suite = CardSuite.Spades, mini, className }) => {
  const mods = useModifiers(styles, 'card', {
    red: suite === CardSuite.Diamonds || suite === CardSuite.Hearts,
    mini: mini,
  });

  let suiteElem;
  switch (suite) {
    case CardSuite.Clubs:
      suiteElem = '\u2663';
      break;
    case CardSuite.Diamonds:
      suiteElem = '\u2666';
      break;
    case CardSuite.Hearts:
      suiteElem = '\u2665';
      break;
    case CardSuite.Spades:
      suiteElem = '\u2660';
      break;
    default:
      throw 'Incorrect card suite received: ' + suite;
  }

  return (
    <div className={`${styles.root} ${className}`}>
      <div className={`${styles.card} ${mods}`}>
        <div className={styles.card__suite}>
          <svg viewBox={`0 0 ${mini ? 112 : 56} 76`} className={styles.card__info}>
            <text x="50%" y="50%" className={`${styles.card__text} ${styles.card__text_suit}`}>
              {suiteElem}
            </text>
          </svg>
        </div>

        <div className={styles.card__value}>
          <svg viewBox={`0 0 ${mini ? 112 : 56} 76`} className={styles.card__info}>
            <text x="50%" y="50%" className={styles.card__text}>
              {value}
            </text>
          </svg>
        </div>

        <div className={styles.card__suite_sub}>
          <svg viewBox={`0 0 ${mini ? 112 : 56} 76`} className={styles.card__info}>
            <text x="50%" y="50%" className={`${styles.card__text} ${styles.card__text_suit}`}>
              {suiteElem}
            </text>
          </svg>
        </div>

        <div className={styles.card__value_sub}>
          <svg viewBox={`0 0 ${mini ? 112 : 56} 76`} className={styles.card__info}>
            <text x="50%" y="50%" className={styles.card__text}>
              {value}
            </text>
          </svg>
        </div>
      </div>
    </div>
  );
};
